import DOMPurify from 'dompurify';

const fragmentFromString = (html: string) => document.createRange().createContextualFragment(html);

const template = ({ sanitizedEmbedHtml }: { sanitizedEmbedHtml: string }) =>
  fragmentFromString(`
    <div class="focuswriter-twitterembed-enhanced">
      ${sanitizedEmbedHtml}
    <div>
  `);

const enhanceFocuswriterTwitterEmbed = () => {
  const elementMatches = document.querySelectorAll('[data-focuswriter-twitterembed]');

  if (
    elementMatches.length &&
    !document.querySelectorAll('script[src="https://platform.twitter.com/widgets.js"]').length
  ) {
    document.head.appendChild(
      fragmentFromString(
        '<script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>',
      ),
    );
  }

  elementMatches.forEach((prevElement) => {
    const embedHtml = prevElement.getAttribute('data-focuswriter-twitterembedhtml');
    if (!embedHtml) return;

    const sanitizedEmbedHtml = DOMPurify.sanitize(embedHtml);
    const nextElement = template({ sanitizedEmbedHtml });
    prevElement.replaceWith(nextElement);
  });
};

export default enhanceFocuswriterTwitterEmbed;
